import { Model } from '@vuex-orm/core'

export default class CustomFieldGroup extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'customFieldGroups'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      name: this.attr(null),
      model_type: this.attr(null),
      position: this.attr(null),
      custom_fields: this.attr(null),
      created_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/CustomFieldGroup.js